import { api_GET, api_POST, api_PUT } from "./_api.js";

const agenda_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Agenda/getlist/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (agendamento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Agenda`, agendamento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default agenda_api;
